import { createSelector } from 'reselect';
import { sortBy, get, compose } from 'lodash/fp';
import { getStringOrUndefinedProp, getStringProp } from '@mews/fp';
import {
    composeProps,
    createAsyncMetaSelectors,
    createPropsExtender,
    DateService,
    DateTimeService,
    TimeService,
} from '@mews/framework';
import { getContainer } from '@mews-commander/legacy-app-instance';
import { createOptionsSelector } from '@mews-commander/utils';
import { getCurrentEnterpriseId } from '@mews-commander/core';
import {
    getCurrentEnterpriseIanaTimeZoneIdentifier,
    currentEnterpriseIdPropsExtender,
} from '@mews-commander/legacy-entities/src/selectors/session/enterprise';
import { getDepartments } from '@mews-commander/legacy-entities/src/ducks/departments';
import { createEntityFormattedMetaSelector } from '@mews-commander/legacy-entities/src/selectors/form';
import { getTask } from '@mews-commander/legacy-entities/src/ducks/tasks';
import { getCurrentEnterpriseAppDateTimeNow } from '@mews-commander/legacy-entities/src/selectors/session/dateTime';
import { getCurrentDateTimeLocalizationInfo } from '@mews-commander/core/legacy-globalization';
import { moduleSelector } from './module';

const getCurrentEnterpriseDepartments = composeProps(
    getDepartments,
    createPropsExtender('enterpriseId', getCurrentEnterpriseId)
);

export const getCurrentDepartmentsOption = createOptionsSelector(getCurrentEnterpriseDepartments, {
    sortFunction: sortBy('label'),
});

export const getTaskFormInitialValues = createSelector(
    getCurrentDateTimeLocalizationInfo,
    getStringOrUndefinedProp('serviceOrderId'),
    getCurrentEnterpriseAppDateTimeNow,
    (localizationInfo, serviceOrderId, nowDateTime) => {
        const newDateTime = DateTimeService.addHours(nowDateTime, 1);

        const newDate = DateTimeService.toDate(newDateTime);
        const newTime = DateTimeService.toTime(newDateTime);

        return {
            date: DateService.toString(newDate, localizationInfo),
            time: TimeService.toShortString(newTime, localizationInfo),
            serviceOrderId,
            name: '',
            description: '',
        };
    }
);

export const getTaskFromProps = composeProps(
    getTask,
    // @ts-expect-error $TSFixMeError: Argument of type 'Selector<ApplicationState, { taskId: string; }, ExtendedProp<"enterpriseId", string>>' is not assignab...
    composeProps(currentEnterpriseIdPropsExtender, createPropsExtender('id', getStringProp('taskId')))
);

export const getTaskFormValues = createSelector(
    getContainer,
    getCurrentEnterpriseIanaTimeZoneIdentifier,
    getTaskFromProps,
    (
        container,
        timezone,
        // @ts-expect-error $TSFixMeError: Type '{}' is not assignable to type 'R3'.
        { deadlineUtc, departmentId, name, description, assigneeProfileId, serviceOrderId, createdUtc } = {}
    ) => {
        const { appLocalizationComponent } = container();

        // @ts-expect-error $TSFixMeError: Argument of type 'unknown' is not assignable to parameter of type 'string'.
        const dateTimeDeadline = DateTimeService.fromUtcString(deadlineUtc, timezone);
        const deadlineDate = appLocalizationComponent.localizeDate(dateTimeDeadline);
        const deadlineTime = appLocalizationComponent.localizeShortTime(dateTimeDeadline);

        // @ts-expect-error $TSFixMeError: Argument of type 'unknown' is not assignable to parameter of type 'string'.
        const dateTimeCreated = DateTimeService.fromUtcString(createdUtc, timezone);
        const createdLocalized = appLocalizationComponent.localizeDateTime(dateTimeCreated);

        return {
            departmentId,
            assigneeProfileId,
            serviceOrderId,
            name,
            description,
            date: deadlineDate,
            time: deadlineTime,
            created: createdLocalized,
        };
    }
);

const getMeta = compose(get('meta'), moduleSelector);
export const [isFetching, hasFailed] = createAsyncMetaSelectors(getMeta);

export const getTaskFormattedMeta = createEntityFormattedMetaSelector(getTask);
